<template>
    <img :src="`${ws}/compra/imagembem/${idBem}`" :alt="alt" style="flex: none !important; height: auto; width: 100%; object-fit: cover;" class="mt-2" />
</template>
<script>
  export default {
    name: 'ImagemBem',
    props: {
      idBem: { type: Number, default: null },
      alt: { type: String, default: '' }
    },
    methods: {
    }
  }
</script>
